module.exports = __webpack_public_path__ + "static/media/evaluateBG.22d642d8.jpg";